<template>
  <div class="content-second">
    <div class="content-second-header">
      <div class="second-wrapper-title">{{ title }}</div>

      <div v-for="(item, index) in TabList" :key="index" style="display: inline-block;">
        <div class="second-wrapper-li" :class="currentTab === item.key ? 'active' : ''" @click="tabClick(item)">{{item.label}}</div>
      </div>

      <div class="content-second-header-right" @click="goMore(currentTab)">更多<a-icon type="right"/></div>
    </div>

    <a-spin :spinning="loading" tip="加载中...">
      <div v-if="dataSource.length" >
        <div v-for="(item, index) in dataSource" class="project-list" :key="index" @click="openNoticePage(item)">
          <div class="project-list-div">
            <slot :item="item"></slot>
          </div>
        </div>
      </div>
      <div v-else class="noData">
        <img src="@/config/images/nodata.png" height="134" width="134" />
        <br />
        <span>暂无数据</span>
      </div>
    </a-spin>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    TabList: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Array,
      default: () => []
    },
    getData: Function,
    openNoticePage: Function,
    goMore: Function
  },
  data() {
    return {
      currentTab: '',
      loading: false
    }
  },
  async mounted() {
    this.loading = true
    this.currentTab = this.TabList[0].key
    await this.getData(this.currentTab)
    this.loading = false
  },
  methods: {
    async tabClick(item) {
      this.loading = true
      this.currentTab = item.key
      await this.getData(this.currentTab)
      this.loading = false
    },
  }
}
</script>

<style lang="less" scoped>
.content-second {
  position: relative;
  .content-second-header {
    justify-content: space-between;
    line-height: 46px;
    background-color: #f6f6f6;
    padding-right: 16px;
    margin-bottom: 16px;
    border-radius: 4px;
    .second-wrapper-title {
      display: inline-block;
      width: 88px;
      height: 46px;
      color: #fff;
      font-weight: 600;
      font-size: 18px;
      text-align: center;
      background: url('@/config/images/newImages/bj1.gif');
    }
    .second-wrapper-li {
      font-size: 16px;
      color: #898989;
      padding: 0 10px;
      cursor: pointer;
    }
    .active {
      color: #0E8FA5;
    }
    .content-second-header-right {
      display: inline-block;
      float: right;
      width: 43px;
      cursor: pointer;
    }
    
    .right-li-btn {
      position: absolute;
      right: 60px;
      padding: 0 8px;
      background-color: #f6f6f6;
      cursor: pointer;
    }
    .left-li-btn {
      position: absolute;
      left:88px;
      padding: 0 8px;
      background-color: #f6f6f6;
      cursor: pointer;
    }
  }
  .project-list {
    height: 40px;
    width: 100%;
    cursor: pointer;
    :hover {
      background-color: #e5efec;
      color: #0E8FA5;
    }
    .project-list-div {
      display: flex;
      justify-content: space-between;
      line-height: 40px;
    }
  }
  .noData {
    text-align: center;
  }
}
</style>